import { useModalContext } from '@sketch/components'
import { useFlag } from '@sketch/modules-common'
import { useVersioning } from 'modules/versioning'

import ShareSettingsModal from '../../../modals/ShareSettingsModal'
import SharingModal from '../../../modals/SharingModal'

export const useShareModal = () => {
  const { share } = useVersioning()
  const { showModal } = useModalContext()
  const isNewSharingOn = useFlag('new-sharing')

  if (isNewSharingOn) {
    return () => {
      showModal(SharingModal, {
        identifier: share.identifier,
        name: share.name,
      })
    }
  }

  return () => {
    showModal(ShareSettingsModal, { share })
  }
}
